import { selector } from '@glitz/core';
import { styled } from '@glitz/react';

export const scrollbarDecorator = styled(
  selector('::-webkit-scrollbar', {
    width: 4,
    height: 12,
  }),
  selector('::-webkit-scrollbar-track', {
    backgroundColor: t => t.scrollbar?.trackColor,
  }),
  selector('::-webkit-scrollbar-thumb', {
    backgroundColor: t => t.scrollbar?.thumbColor,
  }),
);

export const hideScrollbarDecorator = styled(
  selector('::-webkit-scrollbar', {
    display: 'none',
  }),
  {
    scrollbarWidth: 'none',
  },
);
